// extracted by mini-css-extract-plugin
module.exports = {"Story":"Story_Story__3gCbC","Profile":"Story_Profile__355Gt","Seen":"Story_Seen__1uXcv","Not-seen":"Story_Not-seen__YSHaS"};